export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const SET_FACET_TEXT = 'SET_FACET_TEXT';
export const TOGGLE_SHOW_SELECTED = 'TOGGLE_SHOW_SELECTED';

export function clearDataCutSearch() {
  return async dispatch => {
    dispatch({
      type: CLEAR_SEARCH
    });
  };
}
export function setFacetText(text) {
  return async dispatch => {
    dispatch({
      type: SET_FACET_TEXT,
      data: text
    });
  };
}
export function toggleShowSelected() {
  return { type: TOGGLE_SHOW_SELECTED };
}
